<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()" aria-label="Back">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" aria-label="Close">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="full">
    @for (t of tours; track t.id) {
      <ion-item button detail="true" (click)="pick(t)">
        <ion-icon slot="start" name="play-circle-outline" aria-hidden="true"></ion-icon>
        <ion-label>{{ t.label }}</ion-label>
      </ion-item>
    }
  </ion-list>
</ion-content>
